import * as ScoreType from 'constants/ScoreType';
import * as GroupType from 'constants/GroupType';
import * as Period from 'constants/Period';

import * as MatchInfo from 'constants/MatchInfo';

const BANDY_SCORE_MAP = {};
BANDY_SCORE_MAP[Period.NOT_STARTED] = {
    [GroupType.DEFAULT_GROUP]: {
        info: MatchInfo.MATCH_NOT_STARTED,
        main: ScoreType.Match
    },
    [GroupType.FIRST_PERIOD_GROUP]: {
        main: ScoreType.FirstPeriod
    },
    [GroupType.SECOND_PERIOD_GROUP]: {
        main: ScoreType.SecondPeriod
    }
};

BANDY_SCORE_MAP[Period.FIRST] = {
    [GroupType.DEFAULT_GROUP]: {
        main: ScoreType.Match
    },
    [GroupType.FIRST_PERIOD_GROUP]: {
        main: ScoreType.FirstPeriod
    },
    [GroupType.SECOND_PERIOD_GROUP]: {
        main: ScoreType.SecondPeriod
    }
};

BANDY_SCORE_MAP[Period.FIRST_BREAK] = {
    [GroupType.DEFAULT_GROUP]: {
        info: MatchInfo.INTERMISSION,
        main: ScoreType.Match,
        additional: [ScoreType.FirstPeriod]
    },
    [GroupType.SECOND_PERIOD_GROUP]: {
        main: ScoreType.SecondPeriod
    }
};

BANDY_SCORE_MAP[Period.SECOND] = {
    [GroupType.DEFAULT_GROUP]: {
        main: ScoreType.Match,
        additional: [ScoreType.FirstPeriod]
    },
    [GroupType.SECOND_PERIOD_GROUP]: {
        main: ScoreType.SecondPeriod
    }
};

BANDY_SCORE_MAP[Period.FINISHED] = {
    [GroupType.DEFAULT_GROUP]: {
        info: MatchInfo.MATCH_FINISHED,
        main: ScoreType.Match,
        additional: [ScoreType.FirstPeriod]
    }
};

export default BANDY_SCORE_MAP;


// WEBPACK FOOTER //
// ./js/sport-betting/components/grid-control/sportGlossary/Bandy/ScoreMap.js